import { render, staticRenderFns } from "./InputPatente.vue?vue&type=template&id=3e72ded1&scoped=true&"
import script from "./InputPatente.vue?vue&type=script&lang=js&"
export * from "./InputPatente.vue?vue&type=script&lang=js&"
import style0 from "./InputPatente.vue?vue&type=style&index=0&id=3e72ded1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72ded1",
  null
  
)

export default component.exports